export const AUTOCOMPLETE_POPPER_SLOT_PROPS = {
  placement: 'bottom-start',
  modifiers: [
    {
      name: 'flip',
      enabled: false
    }
  ],
  sx: {
    zIndex: 999
  }
}

export const STORE_RELATION_FORM_ALERT_DURATIONS = {
  BRAND_VALIDATION: 7000,
  FLOW_INFO: 5000
}

export const STORE_RELATION_FORM_MODES = {
  CREATE: 'create',
  EDIT: 'edit'
}

export const STORE_RELATION_FORM_ALERT_SX = {
  width: '100%',
  borderRadius: 0,
  mb: 0
}

export const STORE_RELATION_FORM_BASE_INFO_AUTOCOMPLETE_CONFIG = {
  suppliers: {
    key: 'supplier',
    label: 'Proveedor'
  },
  buyers: {
    key: 'buyer',
    label: 'Cadena'
  },
  references: {
    key: 'reference',
    label: 'Referencia'
  },
  clients: {
    key: 'client',
    label: 'Cliente'
  }
}

export const STORE_RELATION_FORM_BASE_INFO_GRID_SX = {
  display: 'grid',
  gap: 1.5,
  gridTemplateColumns: {
    xs: '1fr',
    md: 'repeat(2, minmax(0, 1fr))',
    lg: 'minmax(120px, 0.85fr) minmax(120px, 0.85fr) minmax(180px, 1.15fr) minmax(320px, 2.4fr)'
  },
  alignItems: 'start'
}

export const STORE_RELATION_FORM_ASSIGNMENT_TABLE_COLUMNS = [
  {
    key: 'user',
    label: 'USUARIO',
    className: 'store-relations-user-column'
  },
  {
    key: 'brand',
    label: 'MARCA',
    className: 'store-relations-brands-column-edit'
  },
  {
    key: 'action',
    label: 'ACCION',
    className: 'col-w-50 text-center'
  }
]

export const STORE_RELATION_FORM_ASSIGNMENT_EMPTY_MESSAGES = {
  CREATE: 'Aún no hay asignaciones. Complete los datos para empezar.',
  EDIT: 'No hay asignaciones disponibles para esta relación.'
}

export const STORE_RELATION_FORM_REASSIGNMENT_WARNING_MESSAGES = {
  PRINCIPAL:
    'El usuario principal esta desactivado. Actualiza la relacion y reasigna un usuario activo.',
  USERS_PREFIX:
    'Se detectó un usuario desactivado que debe ser reasignado antes de guardar cambios: '
}

export const STORE_RELATION_FORM_TEXT = {
  LOADING: 'Cargando...',
  NO_OPTIONS: 'No hay resultados',
  LOADING_OPTIONS: 'Cargando opciones...',
  LOADING_BRANDS: 'Cargando marcas...',
  LOADING_USERS: 'Cargando usuarios...',
  CANCEL: 'Cancelar',
  SAVING: 'Guardando...',
  SAVE_CHANGES: 'Guardar cambios',
  CREATE_RELATION: 'Crear relación',
  ASSIGN_USER: 'Asignar usuario',
  CREATE_TITLE: 'Crear nueva relación',
  EDIT_TITLE_PREFIX: 'Editar relación: Cliente - Vendedor',
  REASSIGN_TITLE_PREFIX: 'Reasignar relación',
  EDIT_DESCRIPTION: 'Actualice los datos de la relación seleccionada:',
  ASSIGN_DESCRIPTION: 'Seleccione el usuario principal que se asignará a esta configuración:',
  REASSIGN_DESCRIPTION:
    'Confirme el usuario principal que debe quedar asignado para esta configuración:',
  CREATE_DESCRIPTION: 'Ingrese los siguientes datos para crear una nueva relación:',
  BASE_INFO_SECTION_TITLE: 'Paso 1: Información base',
  BASE_INFO_SECTION_TEXT: 'Selecciona el cliente al que se aplicará esta relación.',
  PRINCIPAL_SECTION_TITLE: 'Paso 2: Usuario principal',
  PRINCIPAL_SECTION_TEXT:
    'Las marcas no asignadas quedarán asignadas por defecto al usuario principal como respaldo.',
  BRAND_ASSIGNMENT_OPTION_TITLE: 'Opción 2.1: ¿Desea permitir asignar usuarios por marca?',
  BRAND_ASSIGNMENT_OPTION_TEXT:
    'Nota: Active esta opción si desea separar las ordenes de compra por usuarios según su relación con las marcas asignadas.',
  BRAND_ASSIGNMENT_OPTION_LABEL: 'Sí, escoger usuarios',
  BRAND_ASSIGNMENT_SECTION_TITLE: 'Paso 3: Asignación de usuarios por marca',
  BRAND_ASSIGNMENT_SECTION_TEXT:
    'Nota: Active esta opción si desea separar las ordenes de compra por usuarios según su relación con las marcas asignadas.',
  USER_SEARCH_LABEL: 'Buscar usuario por nombre o código',
  BRAND_SEARCH_PLACEHOLDER: 'Buscar marca por nombre o código',
  CLIENT_REQUIRED: 'El cliente es obligatorio.',
  PRINCIPAL_REQUIRED: 'El usuario principal es obligatorio.',
  PRINCIPAL_REASSIGN_REQUIRED: 'Selecciona un Usuario principal diferente',
  BRAND_ASSIGNMENTS_DISABLED_ALERT:
    'Desactivó la asignación por marca. Si guarda ahora, las asignaciones cargadas no se enviarán y se perderán.',
  EXISTING_RELATION_MESSAGE: 'Ya existe una relación principal para esta configuración.',
  REASSIGN_USER_ACTION: 'Reasignar usuario',
  DELETE_ACTION: 'Eliminar'
}
